import React, { useState, useEffect, useReducer, useRef } from 'react';
import { useParams } from 'react-router-dom';

import { BASE_URL } from '../BaseURL';

// set our game state with a reducer
const initialState = {
    storyList: [],
    storyIndex: 0
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'appendStoryList':
            return { ...state, storyList: [...state.storyList, action.payload] };
        case 'advanceStoryIndex':
            return { ...state, storyIndex: state.storyIndex + 1 };
    }
};

const Story = ({ storyId, title }) => {
    // Component that renders a story 

    // story state
    const [state, dispatch] = useReducer(reducer, initialState); 
    //const [currentElement, setCurrentElement] = useState(''); // the current element being displayed

    
    // speed of the text animation
    const animationSpeed = 0.03;
    
    /* // need refs for these as they get updated from the event listener
    const storyDictRef = useRef(storyDict);
    const historyRef = useRef(history);
    const currentElementRef = useRef(currentElement);
    const currentPlaceRef = useRef(currentPlace);

    useEffect(() => { storyDictRef.current = storyDict; }, [storyDict]);
    useEffect(() => { historyRef.current = history; }, [history]);
    useEffect(() => { currentElementRef.current = currentElement; }, [currentElement]);
    useEffect(() => { currentPlaceRef.current = currentPlace; }, [currentPlace]); */

    // Inside your component
    const stateRef = useRef(state);

    const storyElementsRef = useRef(null);

    // Update the ref whenever the state changes
    useEffect(() => {
    stateRef.current = state;
    }, [state]);

    // event stream
    useEffect(() => {

        if (!storyId) {
            return;
        }

        // Initialize EventSource
        const eventSource = new EventSource(`${BASE_URL}mikeyandeleanor/story_stream/${storyId}/`);

        // Handle incoming messages
        eventSource.onmessage = (event) => {
            const chunk = JSON.parse(event.data);

            // append the story list
            dispatch({ type: 'appendStoryList', payload: chunk.text });

            console.log(chunk.text);

        }

        // Handle connection open
        eventSource.onopen = () => {
            console.log('Connection to server opened.');
        };

        // Cleanup on component unmount
        return () => {
            eventSource.close();
        };
    }
    , [storyId]);


    // event listeners for advancing the story
    useEffect(() => {
        window.addEventListener("keypress", handleKeyPress);
        window.addEventListener("click", handleKeyPress);
    
        return () => {
            // Clean up the event listener when the component is unmounted
            window.removeEventListener("keypress", handleKeyPress);
            window.removeEventListener("click", handleKeyPress);
        };
    }, []);
    
    // advances to the next element
    const advanceStory = () => {

        console.log('in advanced story');

        if (stateRef.current.storyList.length > stateRef.current.storyIndex + 1) {
            console.log('advancing story');
            dispatch({ type: 'advanceStoryIndex' });
        }
        else {
            console.log(state.storylist);
        }

    };

    // handle key press or click event
    const handleKeyPress = (e) => {

        try {

            // otherwise, advance the story to the next element
            if (e.key === 'Enter' || e.type === 'click') {

                advanceStory();

                // scroll the window down to the bottom
                storyElementsRef.current.scrollBy({ top: 1000000000000, behavior: 'instant' });
            }
        } catch (error) {
            console.log(error);
        }
    };

    // renders a line of text
    const renderText = (words, elementNum, fadeElement = false) => {
        // params: 
        // words: the words to display
        // textStyle: the style of the text
        // delay: the delay before displaying the first word
        // textIndex: the index of the text in the element
        // fadeElement: if the element is the current element aka whether it should be faded in || default: false

        let delay = 0;

        return (
            words.split(' ').map((word, wordIndex) => {
                delay += animationSpeed;

                return (
                    <span
                        className={fadeElement ? 'fade-word' : ''}
                        key={`element-${elementNum}-${wordIndex}`} // Ensure unique key for each span
                        style={{ 
                            animationDelay: fadeElement ? `${delay}s` : 'none'
                        }}
                    >
                        {`${word} `}
                    </span>
                );
            })
        );
    };

    // renders the elements of the story - the history, plus the current element
    const renderStory = () => {


        return (
            <div 
            ref={storyElementsRef}
            className='story-elements-container'>
                
                {state.storyList.map((element, elementIndex) => {

                    if (elementIndex < state.storyIndex) {
                        return (
                            <div
                            className='paragraphs'
                            >
                            {renderText(element, elementIndex, false)}
                            </div>
                        );
                    }

                    if (elementIndex === state.storyIndex) {
                        return (
                            <div
                            className='paragraphs'
                            >
                            {renderText(element, elementIndex, true)}
                            </div>
                        );
                    }
                })}
            </div>
        )
    };




    
    return (
        <div 
            className='story-container' 
            onKeyDown={(e) => handleKeyPress(e)}
        >
            {title && (
                <div 
                className='edge-container header-container'>
                    <div
                    className='story-title'
                    >
                    {title}
                    </div>
                </div>
            )}
            
            
            { renderStory() }


            
        </div>
    );
};

export default Story;
